import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, FieldArray, reduxForm } from "redux-form";
import AppWrapper from "../../Common/AppWrapper/index.jsx";
import { CellAndGeneTherapySequence } from "./CellAndGeneTherapySequence.jsx";
import * as assayActions from "../../../actions/assays.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import _ from "underscore";
import "../AssayCreate.scss";

export const CellAndGeneTherapyForm = ({ fields, custom }) => {
  const validatedAssayDetails = (custom && custom.validatedAssayDetails) || {};
  const formValues =
    custom &&
    custom.formObj &&
    custom.formObj.values &&
    custom.formObj.values.cellAndGeneTherapyForm;

  return (
    <div>
      {fields.map((cellAndGeneTherapyForm, index) => {
        const targetByValue = formValues && formValues[index].targetby;
        const formobj = formValues && formValues[index];
        const values = formValues && formValues[index];

        return (
          <Fragment key={index}>
            <div className="row">
              {targetByValue && targetByValue === "DnaSequence" && (
                <div className="col">
                  <Field
                    name={`${cellAndGeneTherapyForm}.cellandgenetherapysequence`}
                    component={CellAndGeneTherapySequence}
                    index={index}
                    custom={custom}
                  />
                </div>
              )}

              <div className="col-auto">
                <a
                  alt="Remove"
                  title="Remove"
                  className="del-field"
                  href=""
                  onClick={(e) => (e.preventDefault(), fields.remove(index))}
                >
                  <i className="fa fa-minus" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </Fragment>
        );
      })}

      <div className="row">
        <div className="col">
          <div className="btn-add-target">
            <button
              className="outline rounded"
              onClick={(e) => (
                e.preventDefault(),
                fields.push({
                  targetby: "DnaSequence",

                  cellandgenetherapysequence: {
                    assayTargetName: "",
                    fluorophores: "FAM",
                    created_at: epochDate,
                    assayType: "CellAndGeneTherapy",
                  },
                })
              )}
            >
              <i className="fas fa-plus" />
              &nbsp;Add Target
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

CellAndGeneTherapyForm.propTypes = {
  formObj: PropTypes.object,
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  actions: PropTypes.object,
};
const epochDate = new Date().getTime();
